import { createAsyncThunk } from '@reduxjs/toolkit';

import BorrowersApi, { UpdateBorrowerDto } from 'prequalificationV2/api/BorrowersApi';

export const updateBorrowerThunk = (borrowerApi: BorrowersApi) =>
  createAsyncThunk('auth/UpdateBorrower', async (updateBorrowerDto: UpdateBorrowerDto) => {
    return await borrowerApi.updateBorrower(updateBorrowerDto);
  });
